import { useRef, useState } from "react";
import { Dropdown } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import useCloseOnScroll from "hooks/useCloseOnScroll";
import { TEXT_DIRECTION } from "constants/general";
import { DIRECTION } from "services/general";
import { DROPDOWN_MENU_STYLE } from "./constants";
import MenuTrigger from "./MenuTrigger";

/** A breadcrumb menu as a dropdown under its crumb — the wide-screen treatment. */
export default function BreadcrumbDropdown({
  items,
  selectedKeys,
  ariaLabel,
  className,
  children,
}) {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);

  // The menu is portalled to the body (the page column's overflow would clip it),
  // so it has to close rather than float over content scrolling underneath it.
  useCloseOnScroll(triggerRef, open, setOpen);

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
      menu={{
        items,
        selectedKeys,
        onClick: () => setOpen(false),
        style: DROPDOWN_MENU_STYLE,
        // AntD's own submenu arrow does not mirror in Arabic, where submenus open
        // leftwards; the glyph is swapped because AntD positions it with a transform.
        expandIcon: (
          <FontAwesomeIcon
            icon={
              DIRECTION === TEXT_DIRECTION.RTL ? faChevronLeft : faChevronRight
            }
            className="text-[10px] text-text-subtle"
          />
        ),
      }}
    >
      <MenuTrigger
        ref={triggerRef}
        ariaLabel={ariaLabel}
        popupRole="menu"
        open={open}
        className={className}
      >
        {children}
      </MenuTrigger>
    </Dropdown>
  );
}
